import * as React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';

export default function SurveyCheckBox(props) {
    const dispatch = useDispatch();
    const [question, setQuestion] = useState(props.question);

    const [optionsList, setOptionsList] = useState(question.optionList);
    const [state, setState] = useState({});
    const [remarks, setRemarks] = useState({});

    const handleChange = (event) => {
        const { name, checked } = event.target;
        
        //debugger;
        const currOptionId = event.target.getAttribute("option-id");

        // If maxAnswerAttempt is -1 or not defined, allow selecting any number of checkboxes
        if (question.maxAnswerAllowed === -1 || question.maxAnswerAllowed === undefined) {
            setState({
                ...state,
                [currOptionId]: checked,
            });
        } else {
            // Otherwise, check the number of currently selected checkboxes
            const selectedOptionsCount = Object.values(state).filter(value => value).length;
    
            // If the maximum limit has not been reached or the checkbox is being unchecked
            if (selectedOptionsCount < question.maxAnswerAllowed || !checked) {
                setState({
                    ...state,
                    [currOptionId]: checked,
                });
            }
        }
    
        if (checked) {
            setRemarks({
                ...remarks,
                [currOptionId]: '', // Initialize remark with an empty string on check
            });
        } else {
            const { [currOptionId]: removed, ...newRemarks } = remarks; // If uncheked then remove remarks if already exists
            setRemarks(newRemarks);
        }
    };

    const handleRemarkChange = (event) => {
        //debugger;
        const { name, value } = event.target;
        const currOptionId = event.target.getAttribute("option-id");

        setRemarks({
            ...remarks,
            [currOptionId]: value, // Update the corresponding remark
        });
    };

    const handleSubmit = () => {
        const selectedOptions = optionsList.filter(option => state[option.id]);

        var payload = {
            id: question.id
        };

        if(selectedOptions && selectedOptions?.length > 0){
            payload = {
                id: question.id,
                answerList: selectedOptions.map(option => ({
                    questionOptionId: option.id,
                    remark: remarks[option.id] ? remarks[option.id] : '', // Fetch the remark for the selected option
                })),
            };
        }
        
        console.log(payload);
        dispatch(setQuestionAnswerList(payload));
    };

    useEffect(() => {
        handleSubmit(); // Trigger form submission whenever remarks are updated
    }, [remarks]);

    return (
        <Box>
            <FormControl>
                <FormGroup>
                    
                    {optionsList.map((option) => (
                        <div key={option.id}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        id={"question-id-" + question.id + "-option-id-" + option.id}
                                        className={"question-id-" + question.id + "-option-id-" + option.id}
                                        name={"questionList[" + question.questionSequenceNo + "].answerList[" + option.optionSequenceNo + "].questionOptionId"}
                                        checked={state[option.id] || false}
                                        onChange={handleChange}
                                        inputProps={{'option-id': option.id}} // Set the 'option-id' attribute to identify the option
                                    />
                                }
                                label={option.name}
                            />
                            {option.showRemark && state[option.id] && (
                                <TextField
                                    id={"question-id-" + question.id + "-option-id-" + option.id + ".remark"}
                                    className={"question-id-" + question.id + "-option-id-" + option.id + ".remark"}
                                    name={"questionList[" + question.questionSequenceNo + "].answerList[" + option.optionSequenceNo + "].remark"}
                                    inputProps={{'option-id': option.id}} // Set the 'option-id' attribute to identify the remark
                                    label="Remark"
                                    variant="outlined"
                                    value={remarks[option.id] || ''}
                                    onChange={handleRemarkChange}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    style={{ marginTop: '8px' }}
                                />
                            )}
                        </div>
                    ))}
                </FormGroup>
            </FormControl>
        </Box>
    );
}
